import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  commandId: null,
  isDoorOpening: false,
  doorStatus: null,
});

const { Types, Creators } = createActions({
  openDoorRequest: ['controllerId', 'customerId'],
  openDoorRequestSuccess: ['commandId'],
  openDoorRequestFailure: ['errorMessage'],

  checkDoorStatusRequest: ['controllerId', 'commandId'],
  checkDoorStatusRequestSuccess: ['successMessage', 'doorStatus', 'isDoorOpening'],
  checkDoorStatusRequestFailure: ['errorMessage', 'doorStatus'],

  resetStatus: null,
});

export const openDoorRequest = (state) =>
  state.merge({ isLoading: true, isDoorOpening: false, successMessage: null, errorMessage: null, commandId: null });
export const openDoorRequestSuccess = (state, { commandId }) =>
  state.merge({ isLoading: false, isDoorOpening: true, commandId });
export const openDoorRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const checkDoorStatusRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const checkDoorStatusRequestSuccess = (state, { successMessage, doorStatus, isDoorOpening }) =>
  state.merge({ isLoading: false, successMessage, doorStatus, isDoorOpening });
export const checkDoorStatusRequestFailure = (state, { errorMessage, doorStatus }) =>
  state.merge({ isLoading: false, errorMessage, doorStatus, isDoorOpening: false });

export const resetStatus = (state) => state.merge({ doorStatus: null });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.OPEN_DOOR_REQUEST]: openDoorRequest,
  [Types.OPEN_DOOR_REQUEST_SUCCESS]: openDoorRequestSuccess,
  [Types.OPEN_DOOR_REQUEST_FAILURE]: openDoorRequestFailure,

  [Types.CHECK_DOOR_STATUS_REQUEST]: checkDoorStatusRequest,
  [Types.CHECK_DOOR_STATUS_REQUEST_SUCCESS]: checkDoorStatusRequestSuccess,
  [Types.CHECK_DOOR_STATUS_REQUEST_FAILURE]: checkDoorStatusRequestFailure,

  [Types.RESET_STATUS]: resetStatus,
});

export const OpenDoorTypes = Types;
export default Creators;
